/* T&B Symmetry automatic collection loading — preview QA.
   Reuses Symmetry's native AJAX pagination (including existing append behaviour).
   Manual Load more remains a fallback when IntersectionObserver is unsupported. */
(function () {
  if (window.__tnbAutoInfiniteScroll) return;
  window.__tnbAutoInfiniteScroll = true;
  function start() {
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('tnb-auto-scroll-ready');
    var current = null;
    var scheduled = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target !== current) return;
        var link = entry.target;
        observer.unobserve(link);
        if (!link.isConnected || link.dataset.tnbAutoTriggered === '1') return;
        if (!document.querySelector('#product-grid filter-container')) return;
        if (!document.querySelector('#product-grid .collection-listing .product-grid')) return;
        link.dataset.tnbAutoTriggered = '1';
        try { link.focus({preventScroll: true}); } catch (e) { link.focus(); }
        link.click();
      });
    }, { rootMargin: '0px 0px 650px 0px', threshold: 0 });
    function scan() {
      scheduled = false;
      var next = document.querySelector('.template-collection .pagination-row .pagination__next');
      if (next === current) return;
      if (current) observer.unobserve(current);
      current = next;
      if (next && !next.dataset.tnbAutoTriggered) observer.observe(next);
    }
    function scheduleScan() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(scan);
    }
    new MutationObserver(scheduleScan).observe(document.body, {childList:true, subtree:true});
    window.addEventListener('pageshow', scheduleScan);
    scheduleScan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
